(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fitment-finder"] && !Shopify.designMode) return;
  try {
    
(function () {
  "use strict";
  var root = document.querySelector("[data-rvpg-fit]");
  if (!root || root.dataset.rvpgInit) return;
  root.dataset.rvpgInit = "1";

  var STORE = "";
  var IMG = "";
  var DATA_URL = root.dataset.url;
  var HELP = root.dataset.help || "/pages/contact";
  var HEADING = root.dataset.heading || "Will it fit my RV?";
  var INTRO = root.dataset.intro || "Pick your RV brand and we'll show the parts listed for it, then the universal parts that fit most rigs.";
  var money = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
  var ARR = "&rsaquo;";   // breadcrumb separator
  var TICK = "&#10003;";  // confirmed-fit check
  var OTHER = "other";    // "my RV isn't listed" -> universal parts only

  var DATA = null;
  var state = {};
  var PAGE = 24;

  function esc(s){ return String(s==null?"":s).replace(/[&<>"']/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c];}); }
  function fmt(n){ return money.format(Number(n)||0); }
  function has(list, v){ return !!list && list.indexOf(v)>=0; }
  function find(list, k){ for(var i=0;i<list.length;i++){ if(list[i].key===k) return list[i]; } return null; }

  function load(){
    root.innerHTML = '<div class="rvpg-fit__loading">Loading parts finder...</div>';
    fetch(DATA_URL, { cache: "no-cache" })
      .then(function(r){ if(!r.ok) throw new Error("HTTP "+r.status); return r.json(); })
      .then(function(d){ DATA=d; STORE=d.store||""; IMG=d.img||""; fromUrl(); render(); })
      .catch(function(e){ root.innerHTML='<div class="rvpg-fit__empty"><b>Couldn&rsquo;t load the parts finder.</b><br>'+esc(e.message)+'</div>'; });
  }

  // Deep links from product pages, nav and ads: ?rv=jayco, ?rv=black-series&model=HQ19, ?brand=Victron%20Energy, &cat=water
  function fromUrl(){
    var q = new URLSearchParams(location.search);
    var rv = q.get("rv"), brand = q.get("brand"), sel = null;
    if(rv){ sel = rv===OTHER ? otherRv() : find(DATA.rv, rv); if(sel) state={mode:"rv", key:sel.key, label:sel.label}; }
    else if(brand){ sel = find(DATA.vendors, brand); if(sel) state={mode:"vendor", key:sel.key, label:sel.label}; }
    if(!sel) return;
    var model = q.get("model");
    if(model && sel.refine && find(sel.refine, model.toUpperCase())){ state.ref=model.toUpperCase(); state.refineDone=true; }
    var cat = q.get("cat"), c = cat && find(DATA.categories, cat);
    if(c){ state.cat=c.key; state.catLabel=c.label; state.catDone=true; }
  }

  function otherRv(){ return { key:OTHER, label:"Other RV", count:DATA.universal }; }
  function current(){
    if(state.mode==="rv") return state.key===OTHER ? otherRv() : find(DATA.rv, state.key);
    if(state.mode==="vendor") return find(DATA.vendors, state.key);
    return null;
  }

  function crumb(){
    var p = ['<a data-home>Find My Parts</a>'];
    if(state.label) p.push('<b>'+esc(state.label)+'</b>');
    if(state.ref) p.push('<b>'+esc(refLabel())+'</b>');
    if(state.catLabel) p.push('<b>'+esc(state.catLabel)+'</b>');
    return '<div class="rvpg-fit__crumb">'+p.join('<span>'+ARR+'</span>')+'</div>';
  }
  function refLabel(){ var s=current(), r=s&&s.refine&&find(s.refine,state.ref); return r?r.label:state.ref; }
  function bindHome(){ var h=root.querySelector("[data-home]"); if(h) h.onclick=function(){ state={}; render(); }; }

  function render(){
    var s = current();
    if(!s){ state={}; return stepHome(); }
    if(s.refine && !state.refineDone) return stepRefine(s);
    if(!state.catDone) return stepCategory();
    return stepResults();
  }

  function stepHome(){
    var h='<div class="rvpg-fit__head"><h2>'+esc(HEADING)+'</h2><p>'+esc(INTRO)+'</p></div>';
    h+='<div class="rvpg-fit__sub">What RV do you have?</div><div class="rvpg-fit__grid">';
    DATA.rv.forEach(function(b){
      h+='<button class="rvpg-fit__opt" data-mode="rv" data-key="'+esc(b.key)+'">'+esc(b.label)+'<small>'+esc(b.type)+' &middot; '+b.count+' parts</small></button>';
    });
    h+='<button class="rvpg-fit__opt rvpg-fit__opt--other" data-mode="rv" data-key="'+OTHER+'">My RV isn&rsquo;t listed<small>'+DATA.universal+' universal-fit parts</small></button>';
    h+='</div><div class="rvpg-fit__sub">Or shop by parts brand</div><div class="rvpg-fit__chips">';
    DATA.vendors.forEach(function(v){
      h+='<button class="rvpg-fit__opt" data-mode="vendor" data-key="'+esc(v.key)+'">'+esc(v.label)+'<small>'+v.count+(v.count===1?' part':' parts')+'</small></button>';
    });
    h+='</div>';
    root.innerHTML=h;
    root.querySelectorAll("[data-mode]").forEach(function(btn){
      btn.onclick=function(){ state={mode:btn.dataset.mode, key:btn.dataset.key}; state.label=current().label; render(); };
    });
    window.scrollTo(0,0);
  }

  function stepRefine(s){
    var isModel = state.mode==="rv";
    var h=crumb()+'<div class="rvpg-fit__head"><h2>'+(isModel?"Which model?":"What system voltage?")+'</h2><p>'+
      (isModel?"Pick your "+esc(s.label)+" model for confirmed-fit matches, or skip to browse all "+esc(s.label)+" parts.":"Choose your system voltage so we can flag matching "+esc(s.label)+" gear.")+'</p></div>';
    h+='<div class="rvpg-fit__chips">';
    s.refine.forEach(function(r){
      h+='<button class="rvpg-fit__opt" data-ref="'+esc(r.key)+'">'+esc(r.label)+'<small>'+r.count+(r.count===1?' match':' matches')+'</small></button>';
    });
    h+='</div><button class="rvpg-fit__skip" data-skip>'+(isModel?"Not sure / show all "+esc(s.label)+" &rarr;":"Skip &mdash; show all "+esc(s.label)+" &rarr;")+'</button>';
    root.innerHTML=h;
    root.querySelectorAll("[data-ref]").forEach(function(btn){
      btn.onclick=function(){ state.ref=btn.dataset.ref; state.refineDone=true; render(); };
    });
    root.querySelector("[data-skip]").onclick=function(){ state.refineDone=true; render(); };
    bindHome(); window.scrollTo(0,0);
  }

  // Every product that belongs in this RV / brand view, before the category filter.
  // fit: "exact" = model/voltage match, "brand" = listed for this RV brand (or is this vendor), "universal" = universal-fit tag.
  function pool(){
    var rows=[];
    DATA.products.forEach(function(p){
      var fit="";
      if(state.mode==="vendor"){
        if(p.b!==state.key) return;
        fit = state.ref ? (has(p.v,state.ref)?"exact":"brand") : "brand";
      } else if(state.key!==OTHER && has(p.r,state.key)){
        fit = state.ref ? (has(p.m,state.ref)?"exact":"brand") : "brand";
      } else if(p.u){
        fit="universal";
      } else return;
      rows.push({p:p, fit:fit});
    });
    return rows;
  }

  function stepCategory(){
    var counts={}, all=pool();
    all.forEach(function(r){ counts[r.p.c]=(counts[r.p.c]||0)+1; });
    var h=crumb()+'<div class="rvpg-fit__head"><h2>What kind of part?</h2><p>Pick a category, or see everything that fits.</p></div><div class="rvpg-fit__chips">';
    h+='<button class="rvpg-fit__opt" data-cat="" data-label="">All parts<small>'+all.length+'</small></button>';
    DATA.categories.forEach(function(c){
      if(!counts[c.key]) return;
      h+='<button class="rvpg-fit__opt" data-cat="'+esc(c.key)+'" data-label="'+esc(c.label)+'">'+esc(c.label)+'<small>'+counts[c.key]+'</small></button>';
    });
    h+='</div>';
    root.innerHTML=h;
    root.querySelectorAll("[data-cat]").forEach(function(btn){
      btn.onclick=function(){ if(btn.dataset.cat){ state.cat=btn.dataset.cat; state.catLabel=btn.dataset.label; } state.catDone=true; render(); };
    });
    bindHome(); window.scrollTo(0,0);
  }

  var RANK={exact:0, brand:1, universal:2};
  function sortRows(rows, sort){
    var cmp;
    if(sort==="price-asc") cmp=function(a,b){return a.p.p-b.p.p;};
    else if(sort==="price-desc") cmp=function(a,b){return b.p.pm-a.p.pm;};
    else if(sort==="title") cmp=function(a,b){return (a.p.t||"").toLowerCase()<(b.p.t||"").toLowerCase()?-1:1;};
    else cmp=function(){ return 0; };
    // Fit tier always wins; the chosen sort orders within a tier. Array#sort is stable, so "Best fit" keeps catalog order.
    return rows.slice().sort(function(a,b){ return (RANK[a.fit]-RANK[b.fit]) || cmp(a,b); });
  }

  function fitChip(row){
    if(row.fit==="exact") return '<span class="rvpg-fit__fit">'+TICK+' Fits '+esc(refLabel())+'</span>';
    if(row.fit==="universal") return '<span class="rvpg-fit__fit universal">Universal fit</span>';
    if(state.mode==="rv") return '<span class="rvpg-fit__fit brand">'+TICK+' Listed for '+esc(state.label)+'</span>';
    return "";
  }

  function card(row){
    var p=row.p;
    var badge = !p.av ? '<span class="rvpg-fit__badge soldout">Sold out</span>'
      : (p.x && p.x>p.p ? '<span class="rvpg-fit__badge sale">Sale</span>' : '');
    var src = p.i ? (/^https?:|^\/\//.test(p.i) ? p.i : IMG+p.i) : "";
    if(src) src += (src.indexOf("?")<0?"?":"&")+"width=360";
    var imgwrap = src
      ? '<div class="rvpg-fit__imgwrap"><img loading="lazy" src="'+esc(src)+'" alt="'+esc(p.t)+'">'+badge+'</div>'
      : '<div class="rvpg-fit__imgwrap"><div class="rvpg-fit__ph">'+esc((p.t||"?").charAt(0).toUpperCase())+'</div>'+badge+'</div>';
    var price = (p.p===p.pm? fmt(p.p) : "From "+fmt(p.p)) + (p.x && p.x>p.p ? "<s>"+fmt(p.x)+"</s>" : "");
    return '<a class="rvpg-fit__card" href="'+STORE+'/products/'+encodeURIComponent(p.h)+'">'+imgwrap+
      '<div class="rvpg-fit__info">'+fitChip(row)+'<div class="rvpg-fit__name">'+esc(p.t)+'</div><div class="rvpg-fit__price">'+price+'</div></div></a>';
  }

  function note(rows){
    var n={exact:0,brand:0,universal:0};
    rows.forEach(function(r){ n[r.fit]++; });
    var help=' Not sure? <a href="'+esc(HELP)+'">Send us your RV, year and a photo</a> and we&rsquo;ll confirm fit before you order.';
    if(state.mode==="vendor") return state.ref ? '<div class="rvpg-fit__note">Showing <b>'+n.exact+' '+esc(refLabel())+(n.exact===1?' match':' matches')+'</b> first, then other '+esc(state.label)+' parts.</div>' : "";
    if(state.key===OTHER) return '<div class="rvpg-fit__note">These parts are <b>universal fit</b> &mdash; standard sizes and connections used across most RVs. Compare dimensions with the part you&rsquo;re replacing.'+help+'</div>';
    var lead = state.ref
      ? '<b>'+n.exact+' confirmed '+esc(refLabel())+(n.exact===1?' match':' matches')+'</b>'+(n.brand?', then '+n.brand+' other '+esc(state.label)+' parts':'')
      : '<b>'+n.brand+' parts listed for '+esc(state.label)+'</b>';
    return '<div class="rvpg-fit__note">Showing '+lead+(n.universal?', then '+n.universal+' universal-fit parts':'')+
      '. Fit can vary by model, year and floorplan &mdash; <b>check dimensions and part numbers before ordering</b>.'+help+'</div>';
  }

  function stepResults(){
    var sort="featured", shown=PAGE, uni=true;
    var canToggle = state.mode==="rv" && state.key!==OTHER;
    function draw(){
      var rows=pool().filter(function(r){ return (!state.cat || r.p.c===state.cat) && (uni || r.fit!=="universal"); });
      rows=sortRows(rows, sort);
      var vis=rows.slice(0,shown);
      var h=crumb()+'<div class="rvpg-fit__head"><h2>'+esc(state.label)+(state.ref?' &middot; '+esc(refLabel()):'')+(state.catLabel?' &middot; '+esc(state.catLabel):'')+'</h2></div>'+note(rows)+
        '<div class="rvpg-fit__toolbar"><span class="count">'+rows.length+' items</span><div class="rvpg-fit__tools">'+
        (canToggle?'<label><input type="checkbox" data-uni'+(uni?' checked':'')+'> Include universal parts</label>':'')+
        '<select data-sort aria-label="Sort"><option value="featured">Best fit</option><option value="price-asc">Price: low to high</option><option value="price-desc">Price: high to low</option><option value="title">A-Z</option></select></div></div>';
      h+= rows.length ? '<div class="rvpg-fit__results">'+vis.map(card).join("")+'</div>'
        : '<div class="rvpg-fit__empty"><b>No parts found</b><br>Try a broader category, skip the model step, or <a href="'+esc(HELP)+'">ask us to source it</a>.</div>';
      if(shown<rows.length) h+='<button class="rvpg-fit__more" data-more>Load more</button>';
      h+='<button class="rvpg-fit__restart" data-restart>&#8634; Start over</button>';
      root.innerHTML=h;
      var sel=root.querySelector("[data-sort]"); sel.value=sort; sel.onchange=function(){ sort=this.value; shown=PAGE; draw(); };
      var u=root.querySelector("[data-uni]"); if(u) u.onchange=function(){ uni=this.checked; shown=PAGE; draw(); };
      var more=root.querySelector("[data-more]"); if(more) more.onclick=function(){ shown+=PAGE; draw(); };
      root.querySelector("[data-restart]").onclick=function(){ state={}; render(); };
      bindHome();
    }
    draw(); window.scrollTo(0,0);
  }

  load();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.headerCoords = {};
    this.calcHeaderCoords()

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	calcHeaderCoords() {
    const clientRect = this.getBoundingClientRect();
    const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
    this.headerCoords.bottom = pageYOffset + clientRect.bottom;
    this.headerCoords.top = pageYOffset + clientRect.top;
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (this.headerIsAlwaysSticky) {
			if (this.header.classList.contains("color-background-overlay")) {
				if (scrollTop > this.header.offsetHeight + 1) {
					this.header.classList.remove('color-background-overlay');
					this.header.classList.add('color-background-overlay-hidden', 'shopify-section-header-sticky');
				};
			};

			if (this.header.classList.contains('color-background-overlay-hidden')) {
				if (scrollTop < this.header.offsetHeight) {
					this.header.classList.add('color-background-overlay');
					this.header.classList.remove('color-background-overlay-hidden', 'shopify-section-header-sticky');
				};
			};
		}

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
			if (!this.preventReveal) {
				requestAnimationFrame(this.reveal.bind(this));
			} else {
				window.clearTimeout(this.isScrolling);

				this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);

				requestAnimationFrame(this.hide.bind(this));
			}
		} else if (scrollTop <= this.headerCoords.top) {
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');

		if (this.header.classList.contains('color-background-overlay')) {
			this.header.classList.remove('color-background-overlay');
			this.header.classList.add('color-background-overlay-hidden');
		}
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

		if (this.header.classList.contains('color-background-overlay-hidden')) {
			this.header.classList.add('color-background-overlay');
			this.header.classList.remove('color-background-overlay-hidden');
		}
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (typeof DetailsDisclosure !== 'undefined') {
			this.disclosures.forEach((disclosure) => {
				disclosure.close();
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			this.disclosureLists.forEach((disclosureList) => {
				disclosureList.setAttribute('hidden', true);
			});
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.spinnerIcon = this.querySelector('.cart__note-loading');
      this.successIcon = this.querySelector('.cart__note-success');
      this.textarea = this.querySelector('textarea');
      this.cartButtons = document.querySelector('.cart__ctas');

      this.textarea.addEventListener(
        'input',
        debounce((event) => {
          this.spinnerIcon.style.display = 'block';
          this.successIcon.style.display = 'none';
          this.cartButtons.style.pointerEvents = 'none';
          this.cartButtons.style.opacity = '0.7';

          const body = JSON.stringify({ note: event.target.value });

          fetch(`${routes.cart_update_url}`, {
            ...fetchConfig(),
            ...{ body },
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              return response.json();
            })
            .then((data) => {
              this.successIcon.style.display = 'block';

              setTimeout(() => {
                this.successIcon.style.display = 'none';
              }, 2000);
            })
            .catch((error) => {
              console.error('There was a problem with the fetch operation:', error);
            })
            .finally(() => {
              this.spinnerIcon.style.display = 'none';
              this.cartButtons.removeAttribute('style');
            });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      ) {
        activeMedia.loadContent();
      }
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
